import React, { Fragment, useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { paginationComponentOptions } from "../../../Shared/Constants/DatatableConstants";
import { useNavigate } from "react-router";
import TableButtons from "../../../Shared/Components/TableButtons";
import { cititesColums } from "../Data/CititesListColums";
import { deleteConfirmationModal } from "../../../Shared/Components/DeleteConfrimationModal";
import CityContext from "../Context/Index";

const TableCitiesComponent = () => {
  const {
    items,
    setRowsPerPage,
    setCurrentPage,
    currentPage,
    loading,
    rowsPerPage,
    deleteItem,
    totalRows,
    setItem,
    modalTogle,
    fetchItems,
    searchTerm,
  } = useContext(CityContext);

  const [colums, setColums] = useState([]);
  const navigate = useNavigate();
  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1); // Reset to first page
  };

  const handleDelete = (row) => {
    deleteConfirmationModal(row.id, deleteItem);
  };
  const handleEdit = async (row) => {
    setItem(row);
    modalTogle();
  };
  const handleView = (row) => {
    setItem(row);
    navigate(`${process.env.PUBLIC_URL}/app/entities/detail/${row.id}`);
  };
  useEffect(() => {
    setColums([
      ...cititesColums,
      {
        name: "Acciones",
        width: "200px",
        cell: (row) => (
          <TableButtons
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            row={row}
            entity={"entity"}
            showViewButton={false}
          ></TableButtons>
        ),
        ignoreRowClick: true, // Prevent action buttons from triggering row selection
        allowOverflow: true, // Prevent layout overflow issues
        button: true, // Indicate that it's a button column
      },
    ]);
  }, [items]);
  useEffect(() => {
    fetchItems(currentPage, rowsPerPage);
  }, [currentPage, searchTerm]);

  return (
    <Fragment>
      <DataTable
        data={items}
        columns={colums}
        striped={true}
        center={true}
        pagination
        paginationServer // Enables server-side pagination
        paginationTotalRows={totalRows} // Pass total rows to DataTable
        paginationComponentOptions={paginationComponentOptions}
        paginationDefaultPage={currentPage} // Default current page
        paginationPerPage={rowsPerPage} // Rows per page
        onChangePage={handlePageChange} // Handle page change
        onChangeRowsPerPage={handleRowsPerPageChange} // Handle rows per page change
        progressPending={loading} // Show loading spinner
      />
    </Fragment>
  );
};
export default TableCitiesComponent;
